/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const TickerDown: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M7.99998 1.49963C8.55226 1.49963 8.99998 1.94735 8.99998 2.49963V11.8932L11.7568 8.83069C12.1263 8.42024 12.7584 8.38705 13.1689 8.75647C13.5794 9.12592 13.6126 9.75808 13.2431 10.1686L8.74314 15.1686C8.5535 15.3793 8.28347 15.4996 7.99998 15.4996C7.71648 15.4996 7.44646 15.3793 7.25681 15.1686L2.75681 10.1686L2.69236 10.0895C2.39284 9.68041 2.44613 9.10293 2.83103 8.75647C3.21591 8.41011 3.7955 8.41783 4.17088 8.75842L4.24314 8.83069L6.99998 11.8932V2.49963C6.99998 1.94735 7.4477 1.49964 7.99998 1.49963Z'
      fill='currentColor'
    />
  </React.Fragment>
)
